import { useState, useEffect } from "react"
import { useWallet } from "@solana/wallet-adapter-react"
import { LAMPORTS_PER_SOL } from "@solana/web3.js"
import { getConnection } from "@/lib/solana-connection"

export function useWalletBalance() {
    const { publicKey } = useWallet()
    const [balance, setBalance] = useState<number | null>(null)
    const [loadingBalance, setLoadingBalance] = useState(false)

    useEffect(() => {
        if (!publicKey) {
            setBalance(null)
            return
        }

        const fetchBalance = async () => {
            try {
                setLoadingBalance(true)
                const connection = getConnection()
                const bal = await connection.getBalance(publicKey)
                setBalance(bal / LAMPORTS_PER_SOL)
            } catch (error) {
                console.error("Failed to fetch balance:", error)
            } finally {
                setLoadingBalance(false)
            }
        }

        fetchBalance()
    }, [publicKey])

    return { balance, loadingBalance }
}
